import {inject, Injectable} from '@angular/core';

import {NgbModal, NgbModalOptions, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";

import {AutoScrollService} from "@numizmat/services/common";

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  private ngbModal: NgbModal = inject(NgbModal);
  private currentModal: NgbModalRef | null = null;
  private autoScrollService: AutoScrollService = inject(AutoScrollService);

  private isClosedByPopState: boolean = false;

  public open(component: any, options?: NgbModalOptions): NgbModalRef {
    if (this.currentModal) {
      return this.currentModal;
    }
    this.autoScrollService.suppressNextScroll = true;
    this.isClosedByPopState = false;
    this.currentModal = this.ngbModal.open(component, {
      ...options,
      animation: false,
    });
    history.pushState(null, '', location.href);
    window.addEventListener('popstate', this.popStateHandler);
    this.currentModal.result.finally(() => {
      window.removeEventListener('popstate', this.popStateHandler);
      if (!this.isClosedByPopState) {
        this.autoScrollService.suppressNextScroll = true;
        history.back();
      }
      this.currentModal = null;
    });
    return this.currentModal;
  }

  private popStateHandler = () => {
    if (this.currentModal) {
      this.isClosedByPopState = true;
      this.currentModal.close();
    }
  };
}
